import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { CdSpinner } from '@ui';
import { Navigate, Outlet, useLocation } from 'react-router';
import { paths } from '@/app/router/paths';

/** Guards authenticated routes. The MSAL account is the only source of "signed in". */
export const RequireSession = () => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  // Wait for MSAL to settle (e.g. finishing a redirect) before deciding.
  if (inProgress !== InteractionStatus.None) return <CdSpinner variant="overlay" />;
  if (!isAuthenticated) return <Navigate to={paths.landing} replace state={{ from: location }} />;
  return <Outlet />;
};
